export const supabase_url = "https://xowgdbirlorbplkgstmz.supabase.co";
export const supabase_pubkey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJvbGUiOiJhbm9uIiwiaWF0IjoxNjQyNzQzNzcxLCJleHAiOjE5NTgzMTk3NzF9.auplOVy4eqa0s4FkemmdScRGXqSXkADqpcD6OBTKbPA";

